<template>
  <div>
    <div>系统JSON数据集:{{config&&config.id}}</div>
    <Input type="textarea" v-model="datastr"></Input>
    <div v-if="loading">loading...</div>
  </div>
</template>
<script>
import * as dataSysTableApi from "./data-sys-table";
export default {
name:'data-2d-table-editor',
  props: ["config"],
  data() {
    return {
      data:null,
      loading:false,
    };
  },
  computed: {
    datastr:{
      get(){
        return JSON.stringify(this.data||'');
      },
      set(v){
        try {
          this.data = JSON.parse(v);
        } catch (error) {
          
        }
      }
    }
  },
  watch: {
    config: {
      handler() {
        this.loading = true;
        if (this.config && this.config.id) {
          this.getData();
        }else{
            this.$nextTick().then(()=>{
                this.data = [];
                this.loading = false;
            })
            
        }
      },
      immediate: true
    }
  },

  methods: {
    getData() {
      this.loading = true;
      dataSysTableApi.fetch(this.config).then(data => {
        this.data = data;
        this.loading = false;
      });
    },

    update(){
        if(this.config&&this.config.id){
            return dataSysTableApi.update({
                id:this.config&&this.config.id,
                data:JSON.stringify(this.data)
            }).then(()=>{
                let id = this.config.id;
                return {id:id, format:'json'};
            });;
        }else{
            return dataSysTableApi.create({
                data:JSON.stringify(this.data),
                name:Math.random()+''
            }).then((id)=>{
                return {id:id, format:'json'};
            });
        }
    }
  }
};
</script>